import { serviceInstance } from 'libs';

export default {
  createProduct: (body) =>
    serviceInstance.post('v2/products', body).then(({ data }) => ({
      ...data,
    })),
  editProduct: (productId, body) =>
    serviceInstance.put(`v2/products/${productId}`, body).then(({ data }) => ({
      ...data,
    })),
  fetch: (id, params) =>
    serviceInstance
      .get(`v2/products/?merchantId=${id}`, {
        params: { ...params, limit: 20 },
      })
      .then(({ data }) => ({
        ...data,
      })),
  fetchDetails: (code) =>
    serviceInstance.get(`v2/products/${code}`).then(({ data }) => ({
      ...data,
    })),
  fetchProductKeys: (id) =>
    serviceInstance
      .get(`/v2/product-fields/product/${id}/keys`)
      .then(({ data }) => ({
        ...data,
      })),
  fetchProductFields: (id) =>
    serviceInstance
      .get(`/v2/product-fields/product/${id}`)
      .then(({ data }) => ({
        ...data,
      })),
  updateProduct: (body) =>
    serviceInstance.put(`/payments/update`, body).then(({ data }) => ({
      ...data,
    })),
  fetchTransactions: (code, params) =>
    serviceInstance
      .get(`/transaction/product/${code}/all`, {
        params,
      })
      .then(({ data }) => ({
        ...data,
      })),
  createMerchantRegistration: (
    body,
    merchantId,
    onThen = () => {},
    onCatch = () => {},
  ) => {
    serviceInstance
      .post(`/collection/registration/${merchantId}/create`, body)
      .then(onThen)
      .catch(onCatch);
  },
  fetchBusinessSectors: () =>
    serviceInstance.get('/business-sector').then(({ data }) => ({
      ...data,
    })),
  fetchBusinessCategories: (sectorId) =>
    serviceInstance
      .get(`/business-category?sectorId=${sectorId}`)
      .then(({ data }) => ({
        ...data,
      })),
  fetchOfferings: () =>
    serviceInstance.get(`/v2/product-offering`).then(({ data }) => ({
      ...data,
    })),
};
